import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AboutUsComponent} from "./modules/about-us/about-us.component";
import {ShopComponent} from "./modules/shop/shop.component";
import {CartComponent} from "./modules/cart/cart.component";
import {CheckoutComponent} from "./modules/checkout/checkout.component";
import {HomeComponent} from "./modules/home/home.component";
import {ProfileComponent} from "./modules/profile/profile.component";
import {ContactUsComponent} from "./modules/contact-us/contact-us.component";
import {AdminPanelComponent} from "./modules/admin-panel/admin-panel.component";
import {ProductPageComponent} from "./modules/shop/components/product-page/product-page.component";
import {StatusPageComponent} from "./components/status-page/status-page.component";
import {OrderSuccessComponent} from "./modules/order-success/order-success.component";
import {ReturnsPolicyComponent} from "./modules/legal/returns-policy.component";
import {PrivacyPolicyComponent} from "./modules/legal/privacy-policy.component";
import {ProductManageComponent} from "./modules/shop/components/product-manage/product-manage.component";
import {DiscountManageComponent} from "./components/discount-manage/discount-manage.component";
import {EmailMarketingComponent} from "./modules/admin-panel/components/email-marketing/email-marketing.component";
import {BlogDetailComponent} from "./modules/blog/components/blog-detail/blog-detail.component";
import {BlogManageComponent} from "./modules/blog/components/blog-manage/blog-manage.component";
import {BlogListComponent} from "./modules/blog/components/blog-list/blog-list.component";
import {BrandAmbassadorComponent} from "./modules/brand-ambassador/brand-ambassador.component";

export const routes: Routes = [
    {
        path: '',
        component: HomeComponent,
        data: {
            title: 'Алое вера гел МК | Forever Aloe Vera производи со достава',
            metaDescription: 'Forever Living производи со алое вера во Македонија: гел за пиење, нега за лице и тело, пчелни производи. Достава низ цела Македонија, плаќање при достава.',
            canonicalUrl: '/'
        }
    },
    {
        path: 'about-us',
        component: AboutUsComponent,
        data: {
            title: 'За Нас',
            metaDescription: 'Откријте го најдоброто од алое вера! AloeVeraGel.mk нуди производи од Forever Living Products за здравје, убавина, и бизнис можности.',
            canonicalUrl: '/about-us'
        }
    },
    {
        path: 'shop',
        component: ShopComponent,
        data: {
            title: 'Продавница',
            metaDescription: 'Истражете ја нашата продавница со широк избор на алое вера производи и природни додатоци за здравје и убавина. Од алое вера пијалоци до производи за нега на тело, најдете сè што ви треба за природна нега и благосостојба.',
            canonicalUrl: '/shop',
            intro: 'Оригинални Forever Living производи на едно место: алое вера пијалоци, пчелни производи, додатоци во исхрана и козметика за нега. Нарачајте онлајн, платете во готово при достава, а доставата низ цела Македонија трае 2–7 работни дена.'
        }
    },
    {
        path: 'shop/aloe-vera-pijaloci',
        component: ShopComponent,
        data: {
            title: 'Алое вера пијалоци',
            metaDescription: 'Откријте го нашиот избор на алое вера пијалоци за поддршка на вашето здравје и благосостојба. Идеални за хидратација и зајакнување на имунитетот.',
            canonicalUrl: '/shop/aloe-vera-pijaloci',
            intro: 'Алое вера гелот за пиење е најпродаваниот производ на Forever, направен од внатрешниот гел на листот на алое вера. Изберете го класичниот вкус или комбинациите со манго, брусница-јаболко и праска.'
        }
    },
    {
        path: 'shop/pcelni-proizvodi',
        component: ShopComponent,
        data: {
            title: 'Пчелни производи',
            metaDescription: 'Изберете меѓу нашите природни пчелни производи богати со хранливи материи за поддршка на имунитетот и природно здравје. Од мед до прополис, секој производ е внимателно избран.',
            canonicalUrl: '/shop/pcelni-proizvodi',
            intro: 'Пчелни производи од Forever: ливадски мед, пчелен полен, прополис и матичен млеч. Природен додаток во секојдневната исхрана за целото семејство.'
        }
    },
    {
        path: 'shop/dodatoci-vo-ishrana',
        component: ShopComponent,
        data: {
            title: 'Додатоци во исхрана',
            metaDescription: 'Нашите додатоци во исхрана се направени да ги задоволат потребите на вашето тело со есенцијални витамини и минерали. Откријте го идеалниот додаток за вашиот животен стил.',
            canonicalUrl: '/shop/dodatoci-vo-ishrana',
            intro: 'Додатоци во исхрана од Forever: витамини, минерали, омега-3 масни киселини, пробиотици и билни формули. На страницата на секој производ ќе ги најдете составот, препорачаната дневна доза и одговори на најчестите прашања.'
        }
    },
    {
        path: 'shop/licna-nega',
        component: ShopComponent,
        data: {
            title: 'Лична нега',
            metaDescription: 'Грижете се за вашето тело со производи за лична нега кои комбинираат природни состојки за свежина и хидратација. Совршени за секојдневна употреба и здрав сјај.',
            canonicalUrl: '/shop/licna-nega',
            intro: 'Производи за секојдневна лична нега со алое вера: гел за заби, дезодоранс, гел за туширање и шампон. Погодни за целото семејство.'
        }
    },
    {
        path: 'shop/nega-za-lice',
        component: ShopComponent,
        data: {
            title: 'Нега за лице',
            metaDescription: 'Погрижете се за вашето лице со нашите специјално дизајнирани производи за нега на тело. Обновете ја кожата и додадете природен сјај со нашиот избор на производи.',
            canonicalUrl: '/shop/nega-za-lice',
            intro: 'Нега за лице со алое вера: гелови за чистење, тоници, серуми и лосиони. Изберете според типот на кожата и составете ја сопствената рутина.'
        }
    },
    {
        path: 'shop/etericni-masla',
        component: ShopComponent,
        data: {
            title: 'Етерични масла',
            metaDescription: 'Откријте ја моќта на етеричните масла за природна релаксација и баланс. Нашите масла се од висок квалитет и идеални за масажа или ароматерапија.',
            canonicalUrl: '/shop/etericni-masla',
            intro: 'Етерични масла од Forever – лаванда, лимон и други масла за ароматерапија. Се користат во дифузер, разредени во масло за масажа или неколку капки во бања.'
        }
    },
    {
        path: 'shop/nega-za-telo',
        component: ShopComponent,
        data: {
            title: 'Нега за тело',
            metaDescription: 'Пронајдете ги најдобрите производи за нега на тело кои нудат длабока хидратација и заштита. Совршени за сите типови кожа и секојдневна нега.',
            canonicalUrl: '/shop/nega-za-telo',
            intro: 'Нега за тело со алое вера: лосиони за хидратација, креми, спреј за кожа и заштита од сонце. Нега за секој ден и за секое годишно време.'
        }
    },
    {
        path: 'shop/kontrola-na-telesna-tezina',
        component: ShopComponent,
        data: {
            title: 'Контрола на телесната тежина',
            metaDescription: 'Нашите производи за контрола на телесната тежина се внимателно избрани за да ви помогнат на патот кон здравјето и балансот. Откријте го нашиот избор за активен животен стил.',
            canonicalUrl: '/shop/kontrola-na-telesna-tezina',
            intro: 'Програми и производи за контрола на телесната тежина, како Forever Clean 9 и Forever Lean. Најдобри резултати даваат заедно со урамнотежена исхрана и физичка активност.'
        }
    },
    {
        path: 'shop/product/discount/add',
        component: DiscountManageComponent
    },
    {
        path: 'shop/product/discount/:id/edit',
        component: DiscountManageComponent
    },
    {
        path: 'shop/product/add',
        component: ProductManageComponent
    },
    {
        path: 'shop/product/:slugAndId',
        component: ProductPageComponent
    },
    {
        path: 'shop/product/:id/edit',
        component: ProductManageComponent
    },
    {
        path: 'blogs',
        component: BlogListComponent,
        data: {
            title: 'Блог',
            metaDescription: 'Прочитајте ги најновите објави на Непокор.мк.',
            canonicalUrl: '/blogs'
        }
    },
    {
        path: 'blogs/add',
        component: BlogManageComponent
    },
    {
        path: 'blogs/:slugAndId',
        component: BlogDetailComponent
    },
    {
        path: 'blogs/:id/edit',
        component: BlogManageComponent
    },
    {
        path: 'cart',
        component: CartComponent,
        data: {
            title: 'Кошничка',
            metaDescription: 'Вашата кошничка на Непокор.мк. Прегледајте ги избраните производи и продолжете со наплатата за завршување на купувањето.',
            canonicalUrl: '/cart'
        }
    },
    {
        path: 'checkout',
        component: CheckoutComponent,
        data: {
            title: 'Наплата',
            metaDescription: 'Внесете ги вашите податоци за испорака на Непокор.мк. Завршете ја вашата нарачка со пополнување на информациите потребни за испорака.',
            canonicalUrl: '/checkout'
        }
    },
    {
        path: 'profile',
        component: ProfileComponent,
        data: {
            title: 'Профил',
            metaDescription: 'Вашиот кориснички профил на Непокор.мк.',
            canonicalUrl: '/profile'
        }
    },
    {
        path: 'contact-us',
        component: ContactUsComponent,
        data: {
            title: 'Контактирајте нè',
            metaDescription: 'Контактирајте го тимот на Непокор.мк за помош или информации. Пополнете го контакт формуларот или користете ги нашите информации за контакт за испратите порака.',
            canonicalUrl: '/contact-us'
        }
    },
    {
        path: "biznis-moznost",
        component: BrandAmbassadorComponent,
        data: {
            title: 'До Финансиска Слобода со AloeVeraGel.mk',
            metaDescription: 'Остварете финансиска слобода со AloeVeraGel.mk. Претставете ги висококвалитетните алое вера производи и станете дел од успешна глобална заедница.',
            canonicalUrl: '/biznis-moznost'
        }
    },
    {
        path: 'admin-panel',
        component: AdminPanelComponent,
        data: {
            title: 'Админ Панел',
            metaDescription: 'Админ панелот за управување со вашата продавница.',
            canonicalUrl: '/admin-panel'
        }
    },
    {
        path: 'admin-panel/email-marketing',
        component: EmailMarketingComponent
    },
    {
        path: '404',
        component: StatusPageComponent,
        data: {
            title: '404',
            message: 'Извинете, страницата што ја барате не постои.',
            style: 'text-red-600',
            buttonLabel: 'Назад кон почетната страница',
            buttonUrl: '/',
            canonicalUrl: '/404'
        }
    },
    {
        path: '403',
        component: StatusPageComponent,
        data: {
            title: '403',
            message: 'Немате овластување да пристапите до оваа страница.',
            style: 'text-red-600',
            buttonLabel: 'Контактирајте нè',
            buttonUrl: '/contact-us',
            canonicalUrl: '/403'
        }
    },
    {
        path: 'vrakjanje-i-reklamacii',
        component: ReturnsPolicyComponent,
        data: {
            title: 'Враќање и рекламации | aloeveragel.mk',
            metaDescription: 'Неотворен производ можете да го вратите во рок од 15 дена од приемот. Оштетен или погрешен производ го заменуваме без трошок за вас.',
            canonicalUrl: '/vrakjanje-i-reklamacii'
        }
    },
    {
        path: 'politika-za-privatnost',
        component: PrivacyPolicyComponent,
        data: {
            title: 'Политика за приватност | aloeveragel.mk',
            metaDescription: 'Кои лични податоци ги собира aloeveragel.mk при нарачка, зошто ги користи, кому ги дава и кои се вашите права.',
            canonicalUrl: '/politika-za-privatnost'
        }
    },
    {
        path: 'uspesna-naracka',
        component: OrderSuccessComponent,
        data: {
            title: 'Успешна нарачка!',
            canonicalUrl: '/uspesna-naracka'
        }
    },
    {
        path: '**',
        redirectTo: '/404'
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {scrollPositionRestoration: 'top'})],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
